var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyStateEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 69.8125C0 71.5728766 1.42104022 73 3.17391304 73H69.826087C71.5789598 73 73 71.5728766 73 69.8125V22H0v47.8125z",
    fill: "#EEECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.826087 6H3.17391304C1.42104022 6 0 7.432624 0 9.2V22h73V9.2C73 7.432624 71.5789598 6 69.826087 6z",
    fill: "#E2DEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14.4V1.6c0-.883648.671565-1.6 1.5-1.6h3c.828435 0 1.5.716352 1.5 1.6v12.8c0 .883664-.671565 1.6-1.5 1.6h-3c-.828435 0-1.5-.716336-1.5-1.6zM53 14.4V1.6c0-.883648.67158-1.6 1.5-1.6h3c.82842 0 1.5.716352 1.5 1.6v12.8c0 .883664-.67158 1.6-1.5 1.6h-3c-.82842 0-1.5-.716336-1.5-1.6z",
    fill: "#EEECF0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateEvent);
export default __webpack_public_path__ + "static/media/empty-state-event.d3bd5446076bd712a3b190a588ee28d4.svg";
export { ForwardRef as ReactComponent };